import type { RouteObject } from "react-router";
import ContactRoute from "./contact/contact";
import { InspectionsRoute } from "./inspections/inspections-route";
import { inspectionsRoutes } from "./inspections/inspections-routes";
import OverviewRoute from "./overview/overview";
import { DocumentationsRoute } from "./documentations/documentations-route";
import { DeliveryRoute } from "./delivery/delivery-route";
import { deliveryRoutes } from "./delivery/delivery-routes";
import { documentationsRoute } from "./documentations/documentations-routes";
import { CountingsRoute } from "./countings/countings-route";
import { countingsRoutes } from "./countings/countings-routes";
import { DifferentiationsRoute } from "./differentiation/differentiations-route";
import { differentiationsRoute } from "./differentiation/differentiations-routes";

export const processRoutes: RouteObject[] = [
  {
    path: "overview",
    element: <OverviewRoute />,
    index: true,
  },
  {
    path: "contact",
    element: <ContactRoute />,
  },
  {
    path: "delivery",
    element: <DeliveryRoute />,
    children: deliveryRoutes,
  },
  {
    path: "documentation",
    element: <DocumentationsRoute />,
    children: documentationsRoute,
  },
  {
    path: "counting",
    element: <CountingsRoute />,
    children: countingsRoutes,
  },
  {
    path: "differentiation",
    element: <DifferentiationsRoute />,
    children: differentiationsRoute,
  },
  {
    path: "inspection",
    element: <InspectionsRoute />,
    children: inspectionsRoutes,
  },
];
